import React from "react";

export const CHILE = { label: "Chile", value: "CL" }

export const PERU = { label: "Peru", value: "PE" }

export const VENDOR_FORM_SECTION_NAME = 'vendorForm';
export const SHOP_FORM_SECTION_NAME = 'shopForm';
export const COUNTRY_SECTION_NAME = 'country';
export const HEAR_ABOUT_US_SECTION_NAME = 'hear_about_us';
export const OTHER_MARKETS_SECTION_NAME = 'other_markets';
export const DOCUMENT_NUMBER_CLEAN_REGEX = {
  'CL' : /[^0-9kK]/g,
  'PE': /\D/g,
}

export const CONTACT_BY_RIPLEY_OPTION_NAME = 'contactByRipley'
export const APANIO_PYME_OPTION_NAME = 'apanioTuPyme'
export const SOCIAL_NETWORK_OPTION_NAME = 'socialNetwork'
export const ASECH_OPTION_NAME = 'asech'
export const CORFO_OPTION_NAME = 'corfo';
export const MEET_LATAM_OPTION_NAME = 'meetLatam';
export const SERCOTEC_OPTION_NAME = 'sercotec';
export const OTHER_OPTION_NAME = 'other';
export const NONE_OPTION_NAME = 'none';

export const MERCADO_LIBRE_OPTION_NAME = 'mercadoLibre'
export const JUNTOZ_OPTION_NAME = 'juntoz'
export const FALABELLA_OPTION_NAME = 'falabella'
export const SHOPSTAR_OPTION_NAME = 'shopstar'
export const LINIO_OPTION_NAME = 'linio';
export const REAL_PLAZA_GO_OPTION_NAME = 'realPlazaGo';
export const PLAZAVEA_OPTION_NAME = 'plazaVea';

export const ASEP_OPTION_NAME = 'asep';
export const YES_ASEP_ID = 'yesASEP';
export const NO_ASEP_ID = 'noASEP';

export const NO_RESTRICTION_DEPARTMENTS = [ "Lima", "Callao" ]

export const OWN_FLEET_OPTION_NAME = 'own_fleet';
export const YES_OWN_FLEET_ID = 'yesOwnFleet';
export const NO_OWN_FLEET_ID = 'noOwnFleet';

export const OTHER_OPTION_MAX_LENGTH = 100

export const SVC_LOGIN_URL = process.env.REACT_APP_SVC_LOGIN_URL || '#';
export const COUNTRY_INITIAL_STATE = process.env.REACT_APP_COUNTRY_INITIAL_STATE || 'CL';

export const RESEND_EMAIL_URL = '/resend';

export const TOOLTIP_VENDOR_FORM_TITLE="Este usuario será quien administre la tienda y no necesariamente tiene que ser el representador legal"
export const TOOLTIP_AVERAGE_PRODUCTS="Cuantos productos subirías a la plataforma aproximadamente"
export const TOOLTIP_OWN_FLEET="Debes disponer de un Operador logístico o tener flota propia para el despacho de tus productos"
export const WARNING_DEPARTMENT="Si tu ubicación es fuera de los departamentos de Lima o Callao el despacho lo debes realizar con flota propia porque Ripley no dispone de operadores logísticos para tu área."
export const DEPARTMENTS_WITH_OPL=['Lima','Callao']

export const getOnboardingDataInitState = country => ({
  [VENDOR_FORM_SECTION_NAME]: {
    name: '',
    lastname: '',
    phone: '',
    email: '',
    repeat_email: '',
    document_number: '',
  },
  [SHOP_FORM_SECTION_NAME]: {
    business_name: '',
    dte_emit: '',
    commercial_name: '',
    economic_activity: [],
    id_social_reason: '',
    main_category: '',
    quantity_products: '',
    department: '',
    province: '',
    asep: false,
    own_fleet: false,
  },
  [HEAR_ABOUT_US_SECTION_NAME]: {
    [CONTACT_BY_RIPLEY_OPTION_NAME]: false,
    [APANIO_PYME_OPTION_NAME]: false,
    [SOCIAL_NETWORK_OPTION_NAME]: false,
    [ASECH_OPTION_NAME]: false,
    [CORFO_OPTION_NAME]: false,
    [MEET_LATAM_OPTION_NAME]: false,
    [SERCOTEC_OPTION_NAME]: false,
    [OTHER_OPTION_NAME]: false,
    [NONE_OPTION_NAME]: false,
    hear_about_us: '',
  },
  [OTHER_MARKETS_SECTION_NAME]: {
    [MERCADO_LIBRE_OPTION_NAME]: false,
    [JUNTOZ_OPTION_NAME]: false,
    [FALABELLA_OPTION_NAME]: false,
    [SHOPSTAR_OPTION_NAME]: false,
    [LINIO_OPTION_NAME]: false,
    [REAL_PLAZA_GO_OPTION_NAME]: false,
    [PLAZAVEA_OPTION_NAME]: false,
    [OTHER_OPTION_NAME]: false,
    other_markets: '',
    other_markets_added: '',
  },
  [COUNTRY_SECTION_NAME]: {
    country,
  },
})

export const onBoardingDataInitStateCL = getOnboardingDataInitState(CHILE.value)
export const onBoardingDataInitStatePE = getOnboardingDataInitState(PERU.value)
export const onBoardingDataInitState = COUNTRY_INITIAL_STATE === 'CL' ? onBoardingDataInitStateCL : onBoardingDataInitStatePE

export const errorsInitState = {
  [VENDOR_FORM_SECTION_NAME]: {
    name: '',
    lastname: '',
    phone: '',
    email: '',
    repeat_email: '',
    document_number: '',
  },
  [SHOP_FORM_SECTION_NAME] : {
    dte_emit: '',
    commercial_name: '',
    business_name: '',
    main_category: '',
    economic_activity: '',
    id_social_reason: '',
    quantity_products: '',
    department: '',
    province: '',
  },
  [HEAR_ABOUT_US_SECTION_NAME]: {
    hear_about_us: '',
  },
  [OTHER_MARKETS_SECTION_NAME]: {
    other_markets: '',
    other_markets_added: '',
  },
  [COUNTRY_SECTION_NAME]: {
    country: '',
  }
}

export const DIALOG_STATE_INIT = {
  title: <></>,
  type: "default",
  open: false,
  divider: true,
  noButton: false,
  buttonLabels: {
    onCloseLabel: 'Cancelar',
    onSuccessLabel: 'Aceptar',
  },
  actions: {
    onClose: () => {},
    onSuccess: () => {}
  },
  children: <></>,
  hasSecondaryButton: false
}

